<div class="bbva-content">
    <div class="bbva-header">
    </div>

    <div class="content">
        <div class="d-flex align-items-center justify-content-center mt-2 mb-2">
            <img src="./assets/icons/payment_methods/bbvamulti.svg" class="mr-2" alt="bbva logo" height="30">
            <img src="./assets/icons/padlock.svg" alt="padlock" height="15">
        </div>
        <p class="text-size-1" *ngIf="cards.length > 0">Seleccionar una tarjeta usada anteriormente</p>
        <div class="card-list d-flex flex-column">

            <div class="item" *ngFor="let card of cards">
                <div class="card-item" [ngClass]="card.tokenId === cardIdSelected ? 'border-active':'border-inactive'" (click)="selectCard(card)">
                    <p class="mb-0 text-size-1">{{ card.holderName }}</p>
                    <p class="mb-0 text-size-1">**** **** **** {{ card.lastDigits}}</p>
                </div>
                <div class="card-action d-flex justify-content-center align-items-center" matTooltip="Eliminar tarjeta">
                    <img class="cursor-pointer" src="assets/icons/trash.svg" alt="delete" width="25" height="25" (click)="deleteCard(card)">
                </div>
            </div>
            <div class="text-center" *ngIf="cards.length === 0">
                <p class="text-size-1">No se encuentra ninguna tarjeta registrada con BBVA</p>
            </div>

        </div>
    </div>
    <div class="width-100 actions pb-3 pt-3">
        <button mat-raised-button color="primary" class="blue-button width-100" [disabled]="cardIdSelected === ''" (click)="useCard()">
            Aceptar
        </button>
        <button mat-stroked-button class="white-button width-100 ml-0 mt-2" type="button" color="primary" matDialogClose>
            Cancelar
        </button>
        <div class="pt-1 text-center">
            <p class="mb-0 text-size-1 color-omicron text-underline cursor-pointer" (click)="newCard()">+ Pagar con
                tarjeta nueva</p>
        </div>
    </div>

</div>